export default __webpack_public_path__ + "static/media/categories_utility.23280e19.svg";